export const SHIPPINGINFO_OPEN = 'SHIPPINGINFO_OPEN';
export const SHIPPINGINFO_CLOSE = 'SHIPPINGINFO_CLOSE';
